var React = require('react');

function Timeline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M75.58,80.64l58.1-63.84A10,10,0,0,0,126.25,0H10.06A10,10,0,0,0,2.64,16.8L60.73,80.64A10,10,0,0,0,75.58,80.64Z"}));
}

Timeline.defaultProps = {"viewBox":"0 0 136.31 83.92"};

module.exports = Timeline;

Timeline.default = Timeline;
